import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const getSize = value => typeof value === 'number' ? `${value}px` : value;
const SkeletonText = styled.div.withConfig({
  displayName: "ShinySkeletonText__SkeletonText",
  componentId: "sc-12x3y7q-0"
})(["background-color:", ";display:inline-block;border-radius:999px;height:", ";width:", ";"], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  height
}) => height ? getSize(height) : '0.8em', ({
  width
}) => width ? getSize(width) : '6em');

// shimmer animation adapted from https://git.hubteam.com/HubSpot/conversations-skeleton-state
const DURATION = '1s';
const TIMING_FUNC = 'linear';
const DELAY = '0s';
const ITERATION = 'infinite';
const FILL_MODE = 'forwards';
const POSITION_X = 700;
const SHIMMER_ANIMATION = keyframes(["0%{background-position:-", "px 0}100%{background-position:", "px 0}"], POSITION_X, POSITION_X);
const StyledShinySkeletonText = styled(SkeletonText).withConfig({
  displayName: "ShinySkeletonText__StyledShinySkeletonText",
  componentId: "sc-12x3y7q-1"
})(["animation:", " ", " ", " ", " ", " ", ";background:", ";background:", ";background-size:1200px;width:", ";"], SHIMMER_ANIMATION, DURATION, TIMING_FUNC, DELAY, ITERATION, FILL_MODE, ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => `linear-gradient(to right, ${theme.color['fill-field-default']}, ${theme.color['fill-tertiary-default']} 20%, ${theme.color['fill-field-default']} 40%)`, ({
  width
}) => width);
export const ShinySkeletonText = _ref => {
  let restProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledShinySkeletonText, Object.assign({
      "data-loading": "true",
      role: "status"
    }, restProps))
  );
};